import { Col, Form, Input, Modal, Row, Image, Button, Tag } from 'antd';
import { useState } from 'react';
import { toastText } from '../toast';
import connectionService from '../../../client-lib/api/connection-service';
import styles from './index.module.css';

type Props = {
    open: boolean;
    onClose: () => void;
};
const ShopifyModal = ({ open, onClose }: Props) => {
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (values: any): Promise<void> => {
        try {
            setIsLoading(true);
            const data = {
                shopName: values.shopName,
            };
            const response = await connectionService.shopifyAuth(data);
            if (response.result) {
                window.open(response.result.authUrl, '_self');
            } else {
                toastText('Something went wrong, please try again.', 'error');
            }
            handleCancel();
        } catch (error: any) {
            toastText(error.message, 'error');
        } finally {
            setIsLoading(false);
        }
    };
    const handleCancel = () => {
        onClose();
    };
    return (
        <Modal
            open={open}
            onOk={handleSubmit}
            onCancel={handleCancel}
            okText={'Connect'}
            footer={null}
            closable={false}
            className="apiKey_popup"
        >
            <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 16 }}
                style={{ maxWidth: 600 }}
                onFinish={handleSubmit}
                autoComplete="off"
            >
                <div className="center">
                    <Image
                        className={styles['image_shopify']}
                        src="../shopify-logo.png"
                        preview={false}
                    />
                </div>
                <div>
                    <Row gutter={24}>
                        <Col
                            className="gutter-row fields"
                            xs={24}
                            sm={24}
                            md={24}
                            lg={24}
                        >
                            {
                                <>
                                    <div className={styles['form-label']}>
                                        <label>
                                            Store
                                            <span className="required-color">
                                                *
                                            </span>
                                        </label>
                                    </div>

                                    <Form.Item
                                        name="shopName"
                                        wrapperCol={{ span: 24 }}
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    'Please input your store/shop name',
                                            },
                                        ]}
                                        style={{ marginBottom: '10px' }}
                                    >
                                        <Input
                                            size="large"
                                            type="text"
                                            addonBefore="https://"
                                            addonAfter=".myshopify.com"
                                        />
                                    </Form.Item>
                                </>
                            }
                        </Col>
                    </Row>
                </div>
                <div className={styles['modal_footer']}>
                    <Button
                        type="primary"
                        htmlType="submit"
                        size="large"
                        loading={isLoading}
                    >
                        Connect
                    </Button>
                    <Button
                        size="large"
                        htmlType="button"
                        onClick={() => handleCancel()}
                    >
                        Cancel
                    </Button>
                </div>
            </Form>
        </Modal>
    );
};
export default ShopifyModal;
